import { FILTER_CONNECTOR } from 'modules/decision/constants';

export const initialExploreQuery: ExploreQueryT = {
    metrics: [],
    dimensions: [],
    filters: { connector: FILTER_CONNECTOR.and, children: [] },
};
